import React from "react";
import PhoneCall from "../PhoneCall";
import Mail from "../Mail";
import "./IPhone11ProMax18.css";

function IPhone11ProMax18(props) {
  const {
    confirmBooking,
    rectangle98,
    otherDetails,
    bridalLook1,
    event,
    bridalLook2,
    artist,
    seniorSohniJuneja,
    date1,
    date2,
    time,
    x1800Hrs,
    location,
    sjStudioDehradun,
    name,
    enterName,
    line39,
    phoneNo,
    email,
    enterPhoneNumber,
    line40,
    enterEmail,
    line41,
    paymentDetails,
    advanceBookingAmountXxxxxxx,
    gstXxxxxxx,
    line42,
    totalXxxxxxx,
    line43,
    spanText1,
    spanText2,
    proceedToPayment,
    line36,
    contactUs,
    whatsapp,
    phone1,
    phone2,
    junejasohniGmailCom,
    phoneCallProps,
    mailProps,
  } = props;

  return (
    <div className="container-center-horizontal">
      <div className="iphone-11-pro-max-18 screen">
        <div className="flex-col-24">
          <div className="confirm-booking poppins-semi-bold-tundora-16px">{confirmBooking}</div>
          <div className="flex-row-20">
            <div className="flex-col-25">
              <img className="rectangle-98" src={rectangle98} />
              <div className="other-details poppins-medium-tundora-14px">{otherDetails}</div>
            </div>
            <div className="flex-col-26">
              <div className="bridal-look-4 poppins-medium-tundora-14px">{bridalLook1}</div>
              <div className="flex-row-21">
                <div className="event-1 poppins-normal-tundora-14px">{event}</div>
                <div className="bridal-look-5 poppins-medium-tundora-14px">{bridalLook2}</div>
              </div>
              <div className="flex-row-22">
                <div className="artist-1 poppins-normal-tundora-14px">{artist}</div>
                <div className="senior-sohni-juneja poppins-medium-tundora-14px">{seniorSohniJuneja}</div>
              </div>
              <div className="date-container">
                <div className="date poppins-normal-tundora-14px">{date1}</div>
                <div className="date-1 poppins-medium-tundora-14px">{date2}</div>
              </div>
              <div className="flex-row-23">
                <div className="time poppins-normal-tundora-14px">{time}</div>
                <div className="x1800-hrs poppins-medium-tundora-14px">{x1800Hrs}</div>
              </div>
            </div>
          </div>
          <div className="flex-row-24 poppins-medium-tundora-14px">
            <div className="location-1">{location}</div>
            <div className="sj-studio-dehradun">{sjStudioDehradun}</div>
          </div>
          <div className="name-container">
            <div className="name poppins-medium-tundora-14px">{name}</div>
            <div className="enter-name poppins-medium-silver-12px">{enterName}</div>
          </div>
          <img className="line-39" src={line39} />
        </div>
        <div className="flex-row-25">
          <div className="flex-col-27 poppins-medium-tundora-14px">
            <div className="phone-no">{phoneNo}</div>
            <div className="email">{email}</div>
          </div>
          <div className="flex-col-28 poppins-medium-silver-12px">
            <div className="enter-phone-number">{enterPhoneNumber}</div>
            <img className="line-4" src={line40} />
            <div className="enter-email">{enterEmail}</div>
            <img className="line-4" src={line41} />
          </div>
        </div>
        <div className="flex-col-29 poppins-medium-tundora-14px">
          <div className="payment-details">{paymentDetails}</div>
          <p className="advance-booking-amount-xxxxxxx">{advanceBookingAmountXxxxxxx}</p>
          <p className="gst-xxxxxxx">{gstXxxxxxx}</p>
          <img className="line-42" src={line42} />
          <p className="total-xxxxxxx">{totalXxxxxxx}</p>
          <img className="line-43" src={line43} />
          <div className="flex-row-26">
            <div className="rectangle-108 border-1px-sonic-silver"></div>
            <p className="i-agree-to-all-the-terms-and-conditions poppins-medium-tundora-14px">
              <span className="poppins-medium-tundora-14px">{spanText1}</span>
              <span className="span1">{spanText2}</span>
            </p>
          </div>
          <div className="overlap-group1-10">
            <div className="proceed-to-payment poppins-medium-white-16px">{proceedToPayment}</div>
          </div>
          <div className="group-153">
            <img className="line-36-5" src={line36} />
            <div className="contact-us-9 poppins-medium-tundora-14px">{contactUs}</div>
            <div className="flex-row-27">
              <div className="flex-col-30">
                <PhoneCall className={phoneCallProps.className} />
                <img className="whats-app-1" src={whatsapp} />
                <Mail className={mailProps.className} />
              </div>
              <div className="flex-col-31 roboto-normal-tundora-15px">
                <div className="phone-8 valign-text-bottom">{phone1}</div>
                <div className="phone-9 valign-text-bottom">{phone2}</div>
                <div className="junejasohnigmailcom-2 valign-text-bottom">{junejasohniGmailCom}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IPhone11ProMax18;
